<script>
import { formatter } from '@/helpers/formatter'
import { mapActions, mapState } from 'vuex'
export default {
  mixins: [formatter],
  props: {
    orderId: { type: Number },
    price: { type: Object }
  },
  data() {
    return {
      showCreditDialog: false,
      loadingPaymentFromCreditAccount: false
    }
  },
  computed: {
    ...mapState({
      credit: state => state.credit
    })
  },
  created: async function () {
    await this.getCreditBalance()
  },
  methods: {
    ...mapActions(['getCreditBalance']),
    payWithCredit() {
      this.showCreditDialog = false
      this.loadingPaymentFromCreditAccount = true
      this.$ordersService
        .paymentWithCredit(this.orderId)
        .then(() => {
          this.getCreditBalance()
          this.$emit('onPayed')
        })
        .catch(() => {
          this.error = true
        })
        .finally(() => {
          this.loadingPaymentFromCreditAccount = false
        })
    },
    cancelPayment() {
      this.showCreditDialog = false
    }
  }
}
</script>
<template>
  <div>
    <v-dialog v-model="showCreditDialog" max-width="500">
      <v-card class="pa-6">
        <v-card-text
          class="pt-8 pb-8 float-center"
          v-html="
         $t(('component.credit.creditPayment.credit.info.text')
              .replace('{{creditBalance}}',
                formatCurrency(credit.creditBalance)  )
              .replace('{{orderPrice}}', formatCurrency(price.totalGrossPrice)))" >
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn
            id="yesBtn"
            color="primary"
            class="white--text text-capitalize px-8 py-2"
            @click="payWithCredit"
          ><span>{{ $t('global.yes') }}</span></v-btn>
          <v-btn
            id="noBtn"
            color="primary"
            class="white--text text-capitalize px-8 py-2"
            @click="cancelPayment"
          ><span>{{ $t('global.no') }}</span></v-btn>
        </v-card-actions>
        <router-view></router-view>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="loadingPaymentFromCreditAccount"
      persistent
      max-width="500">
      <v-card class="pa-6">
        <v-card-text class="text-center pt-2">
          {{ $t('component.credit.creditPayment.loading.payment.text') }}
        </v-card-text>
        <v-card-text class="text-center pt-4 pb-0">
          <v-progress-circular
            indeterminate
            :size="70"
            :width="7"
            color="primary" >
          </v-progress-circular>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-btn
      id="creditPay"
      color="tertiary"
      class="mt-3 normal-texttransform"
      block
      @click.stop="showCreditDialog = true">
      {{ $t('button.pay.with.credit') }}</v-btn>
  </div>
</template>
